import { BadgeLabelMenuEnum } from "@/utils/enums/BadgeLabelMenuEnum";
import { FeaturesTypePathEnum } from "@/utils/enums/FeaturePathGlobalEnum";

export enum MenuActiveType {
  COMING_SOON = "COMING_SOON",
  HIDDEN = "HIDDEN",
}

interface MenuItem {
  key: string;
  comingSoon: boolean;
  showBadge: {
    enable: boolean;
    label: string;
  };
}

export const homeConfig = {
  blockPath: [`${FeaturesTypePathEnum.CARRENTALS}`],
  mobile: {
    isHiddenMenu: false,
    hidden: [""],
    items: [
      {
        key: `${FeaturesTypePathEnum.FLIGHTS}`,
        comingSoon: false,
        showBadge: {
          enable: false,
          label: `${BadgeLabelMenuEnum.COMINGSOON}`,
        },
      },
      {
        key: `${FeaturesTypePathEnum.HOTELS}`,
        comingSoon: false,
        showBadge: {
          enable: false,
          label: "",
        },
      },
      {
        key: `${FeaturesTypePathEnum.KLUB}`,
        comingSoon: false,
        showBadge: {
          enable: true,
          label: `${BadgeLabelMenuEnum.RECOMMEND}`,
        },
      },
      {
        key: `${FeaturesTypePathEnum.EXPERIENCES}`,
        comingSoon: false,
        showBadge: {
          enable: true,
          label: `${BadgeLabelMenuEnum.RECOMMEND}`,
        },
      },
      {
        key: `${FeaturesTypePathEnum.CARRENTALS}`,
        comingSoon: false,
        showBadge: {
          enable: true,
          label: `${BadgeLabelMenuEnum.RECOMMEND}`,
        },
      },
      {
        key: `${FeaturesTypePathEnum.TOURS}`,
        comingSoon: false,
        showBadge: {
          enable: false,
          label: "",
        },
      },
    ] as MenuItem[],
  },
  desktop: {
    isHiddenMenu: false,
    mainTab: "flights",
    hidden: [""],
    items: [
      {
        key: "flights",
        comingSoon: false,
        showBadge: {
          enable: false,
          label: `${BadgeLabelMenuEnum.COMINGSOON}`,
        },
      },
      {
        key: "hotels",
        comingSoon: false,
        showBadge: {
          enable: false,
          label: "",
        },
      },
      {
        key: "klub",
        comingSoon: false,
        showBadge: {
          enable: true,
          label: `${BadgeLabelMenuEnum.RECOMMEND}`,
        },
      },
    ] as MenuItem[],
  },
};

export const footerConfig = {
  aboutGotherListHidden: ["HowTo"], // langKeyMap
};

export const homeBackgroundBase64 = {
  desktop:
    "data:image/webp;base64,UklGRkYAAABXRUJQVlA4IDoAAACQAQCdASoQAAUABUB8JQBOgBBNySAA/kdOUxrqvrnEXJblbv5bZJ1iEcSut9KuC/9HxATZLAcDSgAA",
  desktopSpecial: "",
  mobile:
    "data:image/webp;base64,UklGRk4AAABXRUJQVlA4IEIAAACQAQCdASoQAAoABUB8JQBdgBCEJ0AAzfEMKo17v5c9d4Y9zKl8s08WbpM4Q6rYip2aCsvo12QDJSV7t8kzpyfmsAA=",
  mobileSpecial: "",
};

export const linkAppStore = {
  ios: {
    url: "https://gother.onelink.me/7TeI/jc33x6td",
    title: "Download on the App Store",
  },
  android: {
    url: "https://gother.onelink.me/Easc/ph0jfjnq",
    title: "GET IT ON Google Play",
  },
};
